import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ShieldCheck } from "lucide-react";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <section data-testid="login-page" className="grid min-h-[80vh] place-items-center bg-[#F9F8F6] px-6 py-20">
      <div className="w-full max-w-md border border-[#D1CCC5] bg-white p-8 md:p-12">
        <span className="grid h-12 w-12 place-items-center bg-[#16302B] text-[#D95D39]">
          <ShieldCheck size={22} strokeWidth={2} />
        </span>
        <p className="eyebrow mt-6">Admin · Sign in required</p>
        <h1 className="mt-3 font-display text-3xl font-black tracking-tight text-[#16302B] sm:text-4xl">
          Mulberry Land Services admin
        </h1>
        <p className="mt-4 text-sm leading-relaxed text-[#5C5C5C]">
          Sign in with the authorized Google account to view and manage quote requests.
        </p>

        <button
          onClick={handleLogin}
          data-testid="login-google-button"
          className="mt-8 inline-flex w-full items-center justify-center gap-3 border-2 border-[#16302B] bg-white px-6 py-4 text-sm font-bold uppercase tracking-wider text-[#16302B] transition-colors hover:bg-[#16302B] hover:text-white"
        >
          <GoogleMark />
          Continue with Google
        </button>

        <p className="mt-6 text-xs text-[#5C5C5C]">
          Only mulberrylandservices@gmail.com can access this area.
        </p>
      </div>
    </section>
  );
}

function GoogleMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden>
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84c-.21 1.13-.84 2.09-1.8 2.73v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.63z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.81 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.71H.96v2.33C2.45 15.98 5.48 18 9 18z" />
      <path fill="#FBBC05" d="M3.97 10.71A5.4 5.4 0 0 1 3.68 9c0-.6.1-1.17.29-1.71V4.96H.96A8.99 8.99 0 0 0 0 9c0 1.45.35 2.83.96 4.04l3.01-2.33z" />
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.47.89 11.43 0 9 0 5.48 0 2.45 2.02.96 4.96l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z" />
    </svg>
  );
}
